<template>
  <div class="web-message-container">
    <basic-form
      ref="basicForm"
      :form-data="formData"
    >
      <template #site_accessKeyId>
        <a-input
          v-decorator="['site_accessKeyId',{rules: [
            { required: false, message: '请输入标签名称' },
          ],}]"
          placeholder="请输入accessKeyId"
        />
      </template>
      <template #site_accessSecret>
        <a-input
          v-decorator="['site_accessSecret',{rules: [
            { required: false, message: '请输入标签名称' },
          ],}]"
          placeholder="请输入accessSecret"
        />
      </template>
      <template #site_signName>
        <a-input
          v-decorator="['site_signName',{rules: [
            { required: false, message: '请输入标签名称' },
          ],}]"
          placeholder="请输入签名名称"
        />
      </template>
      <template #register_sms_code>
        <a-input
          v-decorator="['register_sms_code',{rules: [
            { required: false, message: '请输入标签名称' },
          ],}]"
          placeholder="请输入用户注册模板CODE"
        />
      </template>
      <template #login_sms_code>
        <a-input
          v-decorator="['login_sms_code',{rules: [
            { required: false, message: '请输入标签名称' },
          ],}]"
          placeholder="请输入用户登录模板CODE"
        />
      </template>
      <template #change_sms_code>
        <a-input
          v-decorator="['change_sms_code',{rules: [
            { required: true, message: '请输入标签名称' },
          ],}]"
          placeholder="请输入修改密码模板CODE"
        />
      </template>
    </basic-form>
    <div class="btn-container">
      <a-button
        :loading="btnIsLoading"
        type="primary"
        style="margin-left:20px;"
        @click="$emit('handleSubmit')"
      >
        保存
      </a-button>
    </div>
  </div>
</template>
<script>
import { formDataAli } from '../data/index';
export default {
  props: ['btnIsLoading'],
  data() {
    return {
      formData: formDataAli,
      loading: false,
    };
  },
  mounted() {},

};
</script>
<style lang="scss" scoped>
.web-message-container {
.btn-container{
  text-align: right;
}
}
</style>